/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionExpressionFieldTypeEnum } from './ConditionExpressionFieldTypeEnum';
import {
    ConditionExpressionFieldTypeEnumFromJSON,
    ConditionExpressionFieldTypeEnumFromJSONTyped,
    ConditionExpressionFieldTypeEnumToJSON,
    ConditionExpressionFieldTypeEnumToJSONTyped,
} from './ConditionExpressionFieldTypeEnum';
import type { OperatorEnum } from './OperatorEnum';
import {
    OperatorEnumFromJSON,
    OperatorEnumFromJSONTyped,
    OperatorEnumToJSON,
    OperatorEnumToJSONTyped,
} from './OperatorEnum';

/**
 * A single comparison inside a condition group.
 * @export
 * @interface ConditionExpression
 */
export interface ConditionExpression {
    /**
     * 
     * @type {string}
     * @memberof ConditionExpression
     */
    readonly id: string;
    /**
     * Type of the field being evaluated
     * 
     * * `numeric` - Numeric
     * * `extra_data` - Extra Data
     * * `site_extra_data` - Site Extra Data
     * @type {ConditionExpressionFieldTypeEnum}
     * @memberof ConditionExpression
     */
    fieldType?: ConditionExpressionFieldTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConditionExpression
     */
    fieldName: string;
    /**
     * 
     * @type {OperatorEnum}
     * @memberof ConditionExpression
     */
    operator: OperatorEnum;
    /**
     * 
     * @type {string}
     * @memberof ConditionExpression
     */
    value: string;
    /**
     * Required for 'between' operator
     * @type {string}
     * @memberof ConditionExpression
     */
    value2?: string;
    /**
     * Position of the expression in the group, used for ordering
     * @type {number}
     * @memberof ConditionExpression
     */
    position?: number;
}



/**
 * Check if a given object implements the ConditionExpression interface.
 */
export function instanceOfConditionExpression(value: object): value is ConditionExpression {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('fieldName' in (value as Record<string, any>)) && !('field_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['fieldName'] === undefined && (value as Record<string, any>)['field_name'] === undefined)) return false;
    if (!('operator' in value) || value['operator'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ConditionExpressionFromJSON(json: any): ConditionExpression {
    return ConditionExpressionFromJSONTyped(json, false);
}

export function ConditionExpressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionExpression {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fieldType': json['field_type'] == null ? undefined : ConditionExpressionFieldTypeEnumFromJSON(json['field_type']),
        'fieldName': json['field_name'],
        'operator': OperatorEnumFromJSON(json['operator']),
        'value': json['value'],
        'value2': json['value2'] == null ? undefined : json['value2'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

export function ConditionExpressionToJSON(json: any): ConditionExpression {
    return ConditionExpressionToJSONTyped(json, false);
}

export function ConditionExpressionToJSONTyped(value?: Omit<ConditionExpression, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field_type': ConditionExpressionFieldTypeEnumToJSON(value['fieldType']),
        'field_name': value['fieldName'],
        'operator': OperatorEnumToJSON(value['operator']),
        'value': value['value'],
        'value2': value['value2'],
        'position': value['position'],
    };
}

